<template>
  <user-menu />
</template>

<script>
  import UserMenu from './HeaderUserMenu.vue'

  export default {
    components: {
      UserMenu
    }
  }
</script>
